import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import { confirmation, notify } from '@helpers'
import React from 'react'

export default function CurrentDashboard() {
    const { salon } = useSalonManagerContext()
    const current = salon.api.dashboard.current.use()

    const started = async () => {
        const confirmed = await confirmation("Are you sure you want to send emails regarding this salon to all customers on the website?")
        if (!confirmed) return

        await salon.api.notifications.started()
        notify("Sending email regarding the start of " + salon.state.name + "...")
    }

    const closing = async () => {
        const confirmed = await confirmation("Are you sure you want to send emails regarding the upcoming salon\'s closing date?")
        if (!confirmed) return

        await salon.api.notifications.closing()
        notify("Sending email regarding the upcoming " + salon.state.name + " closing date...")
    }

    const close = () => salon.actions.type.update("voting")

    if (!current.data)
        return null

    return (
        <Grid>
            <Grid gap="15px">
                <Grid gap="0px">
                    <small>Statistics</small>
                    <hr />
                </Grid>
                <Grid columns="4">
                    <EmphasizedContent>
                        <Grid gap="5px">
                            <p>Customers</p>
                            <h3>{current.data.payments} / {current.data.customers}</h3>
                            <small>Paid / Total</small>
                        </Grid>
                    </EmphasizedContent>
                    <EmphasizedContent>
                        <Grid gap="5px">
                            <p>Forgot To Participate</p>
                            <h3>{current.data.forgot_to_participate}</h3>
                            <small>Payment exists. Participations don't.</small>
                        </Grid>
                    </EmphasizedContent>
                    <EmphasizedContent>
                        <Grid gap="5px">
                            <p>Forgot To Pay</p>
                            <h3>{current.data.forgot_to_pay}</h3>
                            <small>Participations exist. Payment doesn't.</small>
                        </Grid>
                    </EmphasizedContent>
                </Grid>
            </Grid>
            <Grid gap="15px">
                <Grid gap="0px">
                    <small>Actions</small>
                    <hr />
                </Grid>
                <Grid columns="4">
                    <Grid gap="10px">
                        <h4>Switch To Voting</h4>
                        <small>Gives juries abillity to vote. Restricts customers from changing the entry.</small>
                        <Button onClick={close} type="tertiary">Switch</Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid gap="15px">
                <Grid gap="0px">
                    <small>Notifications</small>
                    <hr />
                </Grid>
                <Grid columns="4">
                    <Grid gap="10px">
                        <h4>Salon Started!</h4>
                        <small>Sends notifications regarding the start of the salon to all customers on the website.</small>
                        <Button onClick={started} type="tertiary">Notify</Button>
                    </Grid>
                    <Grid gap="10px">
                        <h4>Closing Date Soon!</h4>
                        <small>Sends notifications to salon's participants regarding upcoming closing date.</small>
                        <Button onClick={closing} type="tertiary">Notify</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}